// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30KkM","fullView":"styles_fullView__8_NA5"};